<template>
  <div class="modal fade" :class="show ? 'show' : 'hide'" style="display: block; background-color: rgba(0,0,0,0.3)">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Add question</h4>
          <button class="close" type="button" @click="closePopup"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-between align-items-center">
            <div style="width: 50%">
              <div class="tag-input">
                <span class="input-label">Substance of the question</span>
                <el-input
                    placeholder="Input question"
                    v-model="formData.text"
                />
              </div>
              <div class="tag-input">
                <span class="input-label">Constant value</span>
                <el-input
                    placeholder="Input constant value"
                    v-model="formData.constant"
                />
              </div>
            </div>
            <div class="tag-input d-flex flex-column">
              <span class="input-label">Metric mapping</span>
              <el-select v-model="formData.metric" placeholder="Select metric" value-key="label" style="width: 250px;">
                <el-option-group label="Press Tab/Escape to exit">
                  <el-option
                      v-for="item in metrics"
                      :key="item.name"
                      :label="item.label"
                      :value="item.name">
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" type="button" @click="closePopup">Close</button>
          <button class="btn btn-primary" :class="{disabled: false}" @click="saveTag" type="button">Add tag</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import studyActions from '../../store/modules/studies/actionTypes'

export default {
  name: 'AddQuestionPopup',
  props: {
    metrics: Array,
    mapping: Array
  },
  data () {
    return {
      show: false,
      formData: {
        group: '',
        metric: '',
        text: '',
        constant: ''
      }
    }
  },
  methods: {
    ...mapActions({
      updateQuestion: studyActions.UPDATE_STUDY_MAPPING
    }),
    showPopup (filename) {
      this.formData.group = filename
      this.show = true
    },
    closePopup () {
      this.formData = {
        group: '',
        metric: '',
        text: '',
        constant: ''
      }
      this.show = false
    },
    saveTag () {
      const question = this.mapping.find(el => el.filename === this.formData.group).questions[0]
      const resultsId = question.results_id
      const path = question.path
      const query = {
        text: this.formData.text,
        min: null,
        max: null,
        value: this.formData.constant,
        metric: this.formData.metric,
        attribute: '',
        results_id: resultsId,
        filename: this.formData.group,
        path: path || ''
      }
      this.updateQuestion({
        id: this.$route.params.id,
        query
      })
      this.formData = {
        group: '',
        metric: '',
        text: '',
        constant: ''
      }
      this.$emit('question-added')
      this.show = false
    }
  }
}
</script>

<style scoped>
.hide {
  height: 0;
}

.show {
  height: 100%;
}

.modal-dialog {
  margin-top: 80px;
}

.tag-input {
  margin-top: 10px;
}

.tag-input:first-of-type {
  margin-top: 0;
}

.modal-dialog {
  max-width: 800px;
}

.input-label {
  font-size: 13px;
  margin-left: 3px;
  color: #20a8d8;
}
</style>
